export default __webpack_public_path__ + "assets/ico_copied-0a9f7a6b.svg";